import { Group, NumberInput, Tooltip } from "@mantine/core";
import { useAppStore } from "../../store/appStore";
import { useGridstats } from "../../api/hindcasts";

const DISABLED_MSG = "Select a datasource first";

export function LocationInputs() {
  const { selectedHindcast, lon, lat, setLocation } = useAppStore();
  const { data: gridstats } = useGridstats(selectedHindcast);
  const disabled = selectedHindcast == null;

  const res = gridstats?.meta.res ?? 0.05;
  const decimalScale = Math.max(0, Math.ceil(-Math.log10(res)));
  const step = res;

  function handleLon(value: string | number) {
    const v = typeof value === "number" ? value : parseFloat(value);
    if (!isNaN(v) && lat != null) setLocation(v, lat);
    else if (!isNaN(v)) setLocation(v, lat ?? 0);
  }

  function handleLat(value: string | number) {
    const v = typeof value === "number" ? value : parseFloat(value);
    if (!isNaN(v) && lon != null) setLocation(lon, v);
    else if (!isNaN(v)) setLocation(lon ?? 0, v);
  }

  return (
    <Group id="tour-location" grow gap="sm">
      <Tooltip label={DISABLED_MSG} disabled={!disabled} position="bottom">
        <NumberInput
          label="Longitude"
          placeholder="lon"
          value={lon ?? ""}
          onChange={handleLon}
          disabled={disabled}
          min={-180}
          max={360}
          step={step}
          decimalScale={decimalScale}
          styles={{ label: { color: "#ace8f5" } }}
        />
      </Tooltip>
      <Tooltip label={DISABLED_MSG} disabled={!disabled} position="bottom">
        <NumberInput
          label="Latitude"
          placeholder="lat"
          value={lat ?? ""}
          onChange={handleLat}
          disabled={disabled}
          min={-90}
          max={90}
          step={step}
          decimalScale={decimalScale}
          styles={{ label: { color: "#ace8f5" } }}
        />
      </Tooltip>
    </Group>
  );
}
